import Container from "components/Container";
import routes from "config/routes";
import withScrollToTop from "hocs/withScrollToTop";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import s from "./NotFound.module.css";

const NotFound = ({ isErrorState = false, onReset }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRefresh = () => {
    if (onReset) onReset();
    window.location.reload();
  };

  const handleGoHome = () => {
    if (onReset) onReset();
    navigate(routes.home);
  };

  return (
    <Container>
      <div className={s.wrapper}>
        <div className={s.card}>
          <div className={s.badge}>
            <span className={s.badgeDot} />
            <span>Health Promoting Schools • ННЦРЗ РК</span>
          </div>

          <div className={s.iconWrapper}>
            <div className={s.iconGlow} />
            <div className={s.iconText}>
              {isErrorState ? "⚠️" : "🔍"}
            </div>
          </div>

          <h1 className={s.codeTitle}>
            {isErrorState ? "500" : "404"}
          </h1>

          <h2 className={s.mainTitle}>
            {isErrorState
              ? (t("NotFound.serverErrorTitle") || "Сервис временно недоступен")
              : (t("NotFound.pageNotFound") || "Страница не найдена или недоступна")}
          </h2>

          <p className={s.description}>
            {isErrorState
              ? (t("NotFound.serverErrorDesc") || "Произошла временная техническая задержка. Наша команда уже работает над её устранением. Попробуйте обновить страницу.")
              : (t("NotFound.thePageYouAreLookingForWasNotFound") || "Запрашиваемая страница перемещена, удалена или временно не существует. Воспользуйтесь навигацией ниже.")}
          </p>

          <div className={s.actionsGroup}>
            <button onClick={handleGoHome} className={s.primaryBtn}>
              <span>🏠</span>
              <span>{t("NotFound.goToHomePage") || "Вернуться на главную"}</span>
            </button>

            <button onClick={handleRefresh} className={s.secondaryBtn}>
              <span>🔄</span>
              <span>Обновить страницу</span>
            </button>

            <Link to={routes.news} className={s.ghostBtn}>
              <span>📰</span>
              <span>Новости HPS</span>
            </Link>
          </div>

          <div className={s.footerMeta}>
            <span>Если вам нужна помощь, свяжитесь с администрацией ресурса HPS.</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default withScrollToTop(NotFound);
